<template>
  <div>
    <div class="columns is-multiline">
      <div
        class="card column is-4"
        v-for="message in listeMessages"
        :key="message.id"
      >
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">{{ message.fullName }}</p>
              <p class="subtitle is-6">{{ message.mail }}</p>
              <p class="title is-4">{{ message.sujet }}</p>
            </div>
          </div>

          <div class="content">
            {{ message.content }}
            <br />
            <time>{{ message.fullDate }}</time>
          </div>
          <footer class="card-footer">
            <b-button
              class="card-footer-item is-danger"
              @click="deleteMessage(message)"
              >Supprimer</b-button
            >
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListeMessages from "../classes/ListeMessages.js";

export default {
  name: "ListeProduits",
  created() {
    this.updateListeMessages();
  },
  computed: {
    listeMessages() {
      const resultat = this.$store.state.listeMessages;
      return (resultat || { liste: [] }).liste;
    },
  },
  methods: {
    updateListeMessages: async function () {
      const maListe = new ListeMessages();
      await maListe.getMessages();
    },
    deleteMessage: async function (message) {
      this.$buefy.dialog.confirm({
        title: "Supprimer le message ?",
        message: "Il sera impossible de le récupérer.",
        type: "is-danger",
        hasIcon: true,
        icon: "info-circle",
        ariaRole: "alertdialog",
        ariaModal: true,
        cancelText: "Annuler",
        confirmText: "Supprimer le message",
        onConfirm: async () => {
          await message.deleteMessage();
          this.updateListeMessages();
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.is-sold-out
  background-color: red !important
</style>
